<template>
  <!-- -->
  <div class="license-order">
    <mobile-list :loading="loading" :has-more="searchInfo.hasMore" :query-list="queryList" >
      <list-card class="customer-item" v-for="item in dataList" :key="item.id" :label="accountType(item)" :desc="item.createdTime" @click="toDetail(item)">
        <data-column label="订单id" :show-border="false">{{item.qywxOrderId}}</data-column>
        <data-column label="账号数量" :show-border="false">{{item.accountNumber}}</data-column>
        <data-column label="账号时长" :show-border="false">{{item.accountDuration}}个月</data-column>
      </list-card>
    </mobile-list>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import MobileList from "@/components/qywx/layout/MobileList.vue";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import qywxOrderApi from "@/api/normal/sys/qywxOrderApi";
import util from "@/util/util";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EC",
  components: {
    MobileList, ListCard, DataColumn
  },
  data() {
    return {
      loading: false,
      searchInfo: {
        hasMore: false,
      },
      dataList: [],
      userInfo: {},
    };
  },
  created() {
    util.getUserInfo().then(user => {
      this.userInfo = user
      this.searchInfo.merchantId = user.merchantId;
      this.searchInfo.hasMore = true;
    });

  },
  methods: {
    queryList() {
      this.loading = true;
      qywxOrderApi.queryQywxOrderList(this.searchInfo).then(res => {
        this.dataList = this.dataList.concat(res.records);
        this.searchInfo.totalCount = res.totalCount;
        this.searchInfo.hasMore = res.pageCount > this.searchInfo.pageNumber;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.dataList = [];
      this.queryList();
    },
    accountType(data) {
      return data.accountType === 1 ? "基础账号" : "互通账号"
    },
    toDetail(data) {
      this.router.push(`/qywx/order/license/detail?id=${data.id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.license-order{
  display: flex;
  flex-direction: column;
}
</style>